var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnlinePayment = function SvgOnlinePayment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F384C",
    d: "M5.042 1.875c-1.4 0-2.1 0-2.635.272A2.5 2.5 0 0 0 1.314 3.24c-.272.535-.272 1.235-.272 2.635 0 .35 0 .525.068.659.06.117.155.213.273.273.133.068.308.068.659.068h15.916c.35 0 .525 0 .659-.068a.63.63 0 0 0 .273-.273c.068-.134.068-.309.068-.659 0-1.4 0-2.1-.272-2.635a2.5 2.5 0 0 0-1.093-1.093c-.535-.272-1.235-.272-2.635-.272z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F384C",
    fillRule: "evenodd",
    d: "M1.042 9.125c0-.35 0-.525.068-.659a.63.63 0 0 1 .273-.273c.133-.068.308-.068.659-.068h15.916c.35 0 .525 0 .659.068.117.06.213.156.273.273.068.134.068.309.068.659v5c0 1.4 0 2.1-.272 2.635a2.5 2.5 0 0 1-1.093 1.092c-.535.273-1.235.273-2.635.273H5.042c-1.4 0-2.1 0-2.635-.273a2.5 2.5 0 0 1-1.093-1.092c-.272-.535-.272-1.235-.272-2.635zM5 10.208a.625.625 0 0 0 0 1.25h3.333a.625.625 0 1 0 0-1.25z",
    clipRule: "evenodd"
  })));
};
export default SvgOnlinePayment;